import React from 'react';
import HomePage from '../components/home-page';

export default props => <HomePage urlQuery={props.location.search} />;
